import { toast } from "react-toastify";

const extractMessageString = (err) => {
  if (!err) return "An unexpected error occurred. Please try again.";
  if (typeof err === "string") return err;
  
  if (err.message && typeof err.message === "string") return err.message;
  if (err.data?.message && typeof err.data.message === "string") return err.data.message;
  if (err.response?.data?.message && typeof err.response.data.message === "string") return err.response.data.message;
  if (err.data?.error && typeof err.data.error === "string") return err.data.error;
  if (err.error && typeof err.error === "string") return err.error;
  
  if (Array.isArray(err) && err.length > 0) {
    return err.map((e) => extractMessageString(e)).filter(Boolean).join(", ");
  }

  return "An unexpected error occurred. Please try again.";
};

const sanitizeErrorMessage = (msg) => {
  const strMsg = extractMessageString(msg);
  
  const technicalKeywords = [
    "stream_socket_client",
    "mail.smtp",
    "getaddrinfo",
    "Connection could not be established",
    "SQLSTATE",
    "php_network_getaddresses",
    "Swift_TransportException",
    "Symfony\\Component",
    "Illuminate\\",
  ];

  if (technicalKeywords.some((kw) => strMsg.includes(kw))) {
    return "Mail server connection failed. Please check mail configuration in settings or try again later.";
  }

  return strMsg;
};

const showError = (message) => customToast(message, toast.error);
const showSuccess = (message) => customToast(message, toast.success);

const customToast = (message, toaster) => {
  const cleanMessage = sanitizeErrorMessage(message);
  if (cleanMessage) {
    toaster(cleanMessage);
  }
};

export const ToastifyService = {
  showError,
  showSuccess,
};
